import { useState, useEffect, useCallback } from "react";

export type Tab = "overlay" | "odp";

const PATHS: Record<Tab, string> = {
  overlay: "/overlay-tool",
  odp: "/odp-card-builder",
};

function tabFromPath(): Tab {
  const p = location.pathname;
  if (p === "/odp-card-builder") return "odp";
  return "overlay";
}

export function useTab(): [Tab, (tab: Tab) => void] {
  const [tab, setTabState] = useState<Tab>(tabFromPath);

  const setTab = useCallback((t: Tab) => {
    setTabState(t);
    history.pushState(null, "", PATHS[t]);
  }, []);

  useEffect(() => {
    const onPop = () => setTabState(tabFromPath());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return [tab, setTab];
}
